var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletOutline = function SvgWalletOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.75 6.75h-15a.75.75 0 0 1 0-1.5H18.5a.75.75 0 1 0 0-1.5H5.75A2.26 2.26 0 0 0 3.5 6v12a2.26 2.26 0 0 0 2.25 2.25h15a1.5 1.5 0 0 0 1.5-1.5V8.25a1.5 1.5 0 0 0-1.5-1.5m0 12h-15A.75.75 0 0 1 5 18V8.119c.24.087.494.13.75.131h15zm-4.5-5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
  })));
};
export { SvgWalletOutline as ReactComponent };